<template>
	<div v-bind="c_test_attrs">
		<dropdown
			v-model="c_value"
			:field_meta="dropdownOptions"
			:view_type="view_type"
			:value="currentValue"
			@input="doAction($event)"
			@change="mixin_saveEvent"
		/>
		<div class="ctrl-extraDescr" v-if="c_ctrlParams.extraDescr" v-html="c_ctrlParams.extraDescr"></div>
	</div>
</template>

<script>
	import dropdown from './dropdown.vue'
	import ctrlMixins from './_mixins.js'
	import { ctrlParamsForAll } from './_common-stuff.ts';

	export default {
		name: 'row_access',
		components: {
			dropdown
		},
		meta: { // это наши данные, т.е. вуй при объявлении компонента их не использует
			title: 'Доступ',
			params: {
				...ctrlParamsForAll,
			},
		},
		mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
		props: { // большая часть пропсов приезжает из ctrlMixins!
			value: {
				default: '',
			},
			rowAccess: {
				default: () => ({})
			}
		},
		data: function() {
			return {
				currentValue: this.$props.value || null,
				dropdownOptions: Object.assign({}, this.field_meta, {
					// виртуально собираемый при получении метаданных (util-meta.js) массив групп 3-х типов
					srv_options: JSON.parse(JSON.stringify(this.$props.rowAccess.groups))
				})
			}
		},
		methods: {
			doAction(data) {
				this.currentValue = data;
			}
		}
	}
</script>
